<template>
  <tr
    class="entry-row"
    :class="{
      'h-table__row--warning': !entry.isIssued,
      'h-table__row--error': entry.isExpired,
    }"
  >
    <td class="entry-row__name">
      <div
        :class="{
          'greyed-out': !entry.isIssued,
        }"
      >
        {{ entry.item.serialNumber || '—' }} / {{ entry.item.name || '—' }}
      </div>
      <div class="entry-row__type greyed-out">
        {{ entry.type.name }}
      </div>
    </td>
    <td>
      {{ entry.type.model || '—' }} /
      <span
        :class="{
          'greyed-out': !entry.isIssued && !entry.item.model,
        }"
      >
        {{ entry.item.model || '—' }}
      </span>
    </td>
    <td>
      {{ entry.item.status || 'Не выдан' }}
    </td>
    <td>
      {{ entry.item.issuedAt }}
    </td>
    <td>
      <template v-if="entry.isIssued">
        <a
          v-if="entry.item.issuer.id"
          :href="`/index.php/?r=redesign#/personal-employee/${entry.item.issuer.id}/summary`"
          target="_blank"
        >
          {{ entry.item.issuer.name }}
        </a>
        <template v-else>
          {{ entry.item.issuer.name}}
        </template>
      </template>
    </td>
    <td>
      {{ entry.isIssued ? (entry.item.willExpireAt || '—') : '' }}
    </td>
    <td>
      <a
        v-if="entry.type.responsible"
        :href="`?r=redesign#/personal-employee/${entry.type.responsible.id}/summary`"
        target="_blank"
      >
        {{ entry.type.responsible.name }}
      </a>
      <template v-else>
        —
      </template>
    </td>
    <td>
      <slot />
    </td>
  </tr>
</template>

<script>
export default {
  name: "table-entry-row",
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/vars';

.entry-row {
  &__name {
    padding-left: 43px;
    white-space: nowrap;
  }

  &__type {
    font-size: 11px;
    margin-top: 5px;
    line-height: 110%;
  }
}

.greyed-out {
  color: $label;
}
</style>